import React, { useEffect } from 'react';
import { Container } from '@mui/material';
import Layout from '../../layout';
import { useFetchGraphQL } from '../../hooks';
import GET_FOOTER from '../../query/footer';
import '../legal.scss';

function PrivacyPolicy() {
  const { loading, error, data } = useFetchGraphQL(GET_FOOTER);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (loading) {
    return (
      <Layout>
        <div className="legal-wrap">
          <Container className="legal-container">
            <div className="legal-title">Loading...</div>
          </Container>
        </div>
      </Layout>
    );
  }

  if (error) return <p>Error! {error.message}</p>;

  const footerData = data?.footer;

  return (
    <Layout>
      <div className="legal-wrap">
        <Container className="legal-container">
          <h1 className="legal-title">Privacy Policy</h1>
          <div
            className="legal-content"
            dangerouslySetInnerHTML={{ __html: footerData?.privacyPolicyContent }}
          />
        </Container>
      </div>
    </Layout>
  );
}

export default PrivacyPolicy;
